import(/* webpackMode: "eager", webpackExports: ["default"] */ "/quick/apps/pwa/app/(root)/(home)/HomeRedirector.tsx");
